import artPrintImage from "assets/images/product-category-art-print.jpg";
import digDownloadImage from "assets/images/product-category-digital-download.jpg";
import onchainImage from "assets/images/product-category-onchain-collectible.jpg";
import merchandiseImage from "assets/images/product-category-merchandise.jpg";
import shipYourselfImage from "assets/images/product-category-ship-it-yourself.jpg";
import liveSessionImage from "assets/images/product-category-live-session.jpg";

import type { ProductTemplateSteps, TemplateCategory } from "../types";
import { CreateStepUploadArtwork } from "../components/productWizardSteps/CreateStepUploadArtwork";
import { CreateStepUploadAsset } from "../components/productWizardSteps/CreateStepUploadAsset";
import { StepArtPrintOptions } from "../components/productWizardSteps/StepArtPrintOptions";
import { StepArtPrintPricing } from "../components/productWizardSteps/StepArtPrintPricing";
import { StepConfirmation } from "../components/productWizardSteps/StepConfirmation";
import { StepDetails } from "../components/productWizardSteps/StepDetails";
import { StepPricing } from "../components/productWizardSteps/StepPricing";
import { StepProductMedia } from "../components/productWizardSteps/StepProductMedia";
import { StepTokenDetails } from "../components/productWizardSteps/StepTokenDetails";

const templateCategories: {
  // template name
  name: TemplateCategory;

  // readable title, if necessary
  title?: string;
  description?: string;
  image: string;
}[] = [
  {
    name: "Fine Art Print",
    description: "Print on Demand",
    image: artPrintImage,
  },
  {
    name: "Onchain Collectible",
    image: onchainImage,
  },
  {
    name: "Digital Download",
    image: digDownloadImage,
  },
];

const comingSoonTemplates: {
  // template name
  name: string;

  // readable title, if necessary
  title?: string;
  description?: string;
  image: string;
}[] = [
  {
    name: "Merchandise",
    image: merchandiseImage,
    description: "Print on Demand",
  },
  {
    name: "Ship it Yourself",
    image: shipYourselfImage,
  },
  {
    name: "Live Session",
    image: liveSessionImage,
  },
];

const productTemplateSteps: ProductTemplateSteps[] = [
  /**
   * Print on Demand Templates
   */
  {
    id: "PRODIGI-PRINTS",
    name: "Art Print",
    templateCategory: "Fine Art Print",
    CreateStep: CreateStepUploadArtwork,
    steps: [
      StepDetails,
      StepArtPrintOptions,
      StepArtPrintPricing,
      StepConfirmation,
    ],
    validate: {},
  },

  /**
   * Onchain Asset Templates
   */
  {
    id: "HUG-ON-CHAIN",
    name: "HUG Contract",
    templateCategory: "Onchain Collectible",
    CreateStep: CreateStepUploadArtwork,
    steps: [
      StepDetails,
      StepProductMedia,
      StepTokenDetails,
      StepPricing,
      StepConfirmation,
    ],
    validate: {
      productMedia: (media) =>
        media.length > 0 || "This product needs at least one image.",
    },
  },

  /**
   * Digital Downloads
   */
  {
    id: "HUG-DIGITAL-DOWNLOADS",
    name: "Digital Download",
    templateCategory: "Digital Download",
    CreateStep: CreateStepUploadAsset,
    steps: [StepDetails, StepProductMedia, StepPricing, StepConfirmation],
    validate: {
      productMedia: (media) =>
        media.length > 0 || "This product needs at least one image.",
    },
  },
];

export { productTemplateSteps, templateCategories, comingSoonTemplates };
